import React, { useEffect, useState } from 'react';
import LevelForm from '../../../components/levels/LevelForm';
import { createLevelManager, updateLevelManager, getLevel } from '../../../api/levels';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeaderSection from '../../../components/layout/PageHeaderSection';
import PageLoadingShell from '../../../components/layout/PageLoadingShell';
import { apiErrorMessage } from '../../../utils/apiError';

const ManagerLevelFormPage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const isEdit = !!id;
    const [initial, setInitial] = useState(null);
    const [loading, setLoading] = useState(isEdit);
    const [loadError, setLoadError] = useState('');
    const navigate = useNavigate();

    const title = isEdit ? t('managerForms.editLevel') : t('managerForms.addLevel');
    const subtitle = t('managerForms.levelSubtitle');

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setLoadError('');
            try {
                const res = await getLevel('MANAGER', id);
                if (res.data) setInitial(res.data);
                else setLoadError(t('forms.level.loadFailed', { defaultValue: 'Could not load this level.' }));
            } catch (e) {
                setLoadError(apiErrorMessage(e, t('forms.level.loadFailed', { defaultValue: 'Could not load this level.' })));
            } finally {
                setLoading(false);
            }
        };
        if (isEdit) load();
    }, [id, isEdit, t]);

    const onSubmit = async (payload) => {
        try {
            if (isEdit) {
                await updateLevelManager(id, payload);
            } else {
                await createLevelManager(payload);
            }
            navigate('/manager/levels');
        } catch (e) {
            alert(t('managerForms.saveFailed'));
        }
    };

    if (loading) {
        return (
            <PageLoadingShell
                variant="page-shell-form"
                title={title}
                subtitle={subtitle}
            />
        );
    }

    if (isEdit && (loadError || !initial)) {
        return (
            <div className="page-shell-form">
                <PageHeaderSection title={title} subtitle={subtitle} />
                <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
                    {loadError || t('forms.level.loadFailed', { defaultValue: 'Could not load this level.' })}
                </div>
                <button type="button" className="mt-4 text-sm font-semibold text-slate-700 underline" onClick={() => navigate('/manager/levels')}>
                    {t('forms.common.back', { defaultValue: 'Back' })}
                </button>
            </div>
        );
    }

    return (
        <div className="page-shell-form">
            <PageHeaderSection title={title} subtitle={subtitle} />
            <LevelForm
                role="MANAGER"
                initial={initial}
                onSubmit={onSubmit}
                onCancel={() => navigate('/manager/levels')}
                submitLabel={isEdit ? t('forms.common.update') : t('forms.common.create')}
            />
        </div>
    );
};

export default ManagerLevelFormPage;
